import React from 'react';

import { ArrowRight } from 'lucide-react';

import { convertMRRToTimeframe } from 'common/company/RevenueHelpers';
import styles from 'css-module/components/subdomain/admin/AdminQueue/_Suggestion.module.scss';

import AdminQueuePost from './AdminQueuePost';

import type { Board } from 'common/api/endpoints/boards';
import type { Company } from 'common/api/endpoints/companies';
import type { StrippedUser } from 'common/api/endpoints/users';

interface CommonPostSuggestionProps {
  title: string;
  details: string | null;
  author: StrippedUser | undefined;
  created?: string;
  board?: Board;
}

interface UniquePostSuggestionProps extends CommonPostSuggestionProps {
  onClick: () => void;
}

export const UniquePostSuggestion = ({
  author,
  board,
  created,
  details,
  onClick,
  title,
}: UniquePostSuggestionProps) => (
  <button className={styles.queueItemWrapper} onClick={onClick}>
    <AdminQueuePost
      className={styles.queueSuggestionItem}
      title={title}
      details={details}
      author={author}
      created={created}
      board={board}
    />
  </button>
);

interface DuplicatePostSuggestionsProps extends CommonPostSuggestionProps {
  company: Company;
  duplicatePost: CommonPostSuggestionProps & {
    score: number;
    commentCount: number;
    totalMRR: number;
  };
  onClickDuplicatePost: () => void;
  onClickOriginalPost: () => void;
}

export const DuplicatePostSuggestion = ({
  author,
  board,
  company,
  created,
  details,
  title,
  duplicatePost,
  onClickDuplicatePost,
  onClickOriginalPost,
}: DuplicatePostSuggestionsProps) => (
  <div className={styles.duplicateQueueItem}>
    <button className={styles.queueItemWrapper} onClick={onClickDuplicatePost}>
      <AdminQueuePost
        title={title}
        details={details}
        author={author}
        created={created}
        board={board}
      />
    </button>
    <ArrowRight className={styles.mergeButton} strokeWidth={1} width={32} />
    <button className={styles.queueItemWrapper} onClick={onClickOriginalPost}>
      <AdminQueuePost
        title={duplicatePost.title}
        details={duplicatePost.details}
        author={duplicatePost.author}
        created={duplicatePost.created}
        board={board}
        meta={{
          score: duplicatePost.score,
          commentCount: duplicatePost.commentCount,
          ...(company.hasCollectedMonthlySpend && {
            monthlySpend: convertMRRToTimeframe(duplicatePost.totalMRR, company.revenueTimeframe),
          }),
        }}
      />
    </button>
  </div>
);
